// core
import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-delete-modal',
    templateUrl: 'delete-modal.component.html',
    styleUrls: ['delete-modal.component.scss'],
    standalone: false
})

export class DeleteConfirmationModalComponent implements OnInit {

  @Output() onHide: EventEmitter<any> = new EventEmitter<any>();

  @Input() firstName: string;
  @Input() lastName: string;

  @Input() whichPage: string;
  @Input() disabled: boolean = false;
  @Input() disabledTooltip: string = '';

  private nameOfWhatToDelete: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if ('firstName' in simpleChange || 'lastName' in simpleChange) {
      this.nameOfWhatToDelete = this.firstName && this.lastName ? ("'" + this.firstName + ' ' + this.lastName + "'") : '';
    }
  }

  public getNameOfWhatToDelete() {
    return this.nameOfWhatToDelete;
  }

  public getAnswer(answer: boolean) {
    this.onHide.emit(answer);
  }
}
